<script>
  import { Col, Container, Row } from "sveltestrap";

  import CentralineList from "./Centraline/CentralineList.svelte";
  import CustomNavbar from "./Layout/CustomNavbar.svelte";
  import About from "./About/About.svelte";

  import config from "./config.json";
  import { _ } from "./i18n.js";
  import CentralineHistory from "./Centraline/CentralineHistory.svelte";

  export let title;
  let width;
  let selected = "dashboard";
</script>

<Container fluid>
  <div bind:clientWidth={width}>
    <Row class="align-items-center">
      <Col class="d-flex justify-content-center align-items-center">
        <img src="images/logodip.png" class="img-fluid logo" alt="Logo" />
        <h1 class="ps-1">{title}</h1>
      </Col>
    </Row>

    <Row>
      <Col>
        <!-- <Navbar light color="light" >
            <Nav class="md-auto" pills>
                <NavItem><NavLink  href="#" on:click={()=> {selected = 'dashboard'}} active={selected === 'dashboard'}>Dashboard</NavLink></NavItem>
                <NavItem><NavLink  href="#" on:click={()=> {selected = 'about'}} active={selected === 'about'}>About</NavLink></NavItem>
            </Nav>
        </Navbar> -->
        <CustomNavbar
          items={config.menu}
          current={selected}
          selectItem={(event) => (selected = event.target.id)}
        />
        {#if selected === "dashboard"}
          <Container fluid class="d-flex justify-content-center bg-light">
            <h5>
              {$_("updateEvery") +
                " " +
                config.updateTime / 60000 +
                " " +
                $_("minutes")}
            </h5>
          </Container>

          <CentralineList colsNumber={width > 800 ? 2 : 1} />
        {:else if selected === "history"}
          <CentralineHistory />
        {:else}
          <Container fluid class="mt-1"><About name="About" /></Container>
        {/if}
      </Col>
    </Row>
  </div>
</Container>

<style>
  img.logo {
    max-height: 70px;
  }
</style>
